import { Component, OnInit, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { element } from 'protractor';
import { NameDtl, CodeValue, CodedLookup } from '../../core/index.model';
import { SessionStorageService, PageContentService, AddressService, DataService, CommonService, ParameterConfigService, MobileattachService } from '../../core/index.service';
import { Router } from '@angular/router';
import { Item } from '@syncfusion/ej2-navigations';
import { TxtAttach } from '../../core/txtattach.model';
import { Guid } from '../../core/guid';
import { MobileAttach } from '../../core/mobile-attach.model';
@Component({
  selector: 'app-mobileattachlink',
  templateUrl: './mobileattachlink.component.html',
  styleUrls: ['./mobileattachlink.component.css']
})
export class MobileattachlinkComponent  {

    AttachIcon= [];
    image: string;
    retrivePic: any;
    RetrivePic: boolean = false;
    // docUploading: boolean = false;
    PhonePicres: any;
    AuthCode: number;
    sendOTP: boolean = false;
    alert: Alert;
    @ViewChild('phonenumber') phonenumber;
    mobileAttach: MobileAttach;
    attachments: TxtAttach[] = [];
    enableOTP: string;
    interval : any
    constructor(

        @Inject(MAT_DIALOG_DATA) public dialogData: any,
        public mblLinkdialogRef: MatDialogRef<MobileattachlinkComponent>,
        private fb: FormBuilder,
        private router: Router,
        private dialog: MatDialog,
        private storageService: SessionStorageService,
        private pagecontentService: PageContentService,
        private dataService: DataService,
        private addressService: AddressService,
        private commonService: CommonService,
        private parameterConfigService: ParameterConfigService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private mobileAttachService: MobileattachService
    ) {          
        this.enableOTP = this.parameterConfigService.GetSystemParamValue(96);
        this.alert = new Alert();
        this.alert.showOkBtn = true;

        if (data && data.message) {
            this.alert.message = data.message;
        }
        else {
            this.alert.message = data;
        }

        if (data && data.message1) {
            this.alert.message1 = data.message1;
        }
        else {
            this.alert.message1 = data;
        }

        if (data && data.Success) {
            this.alert.Success = true;
        }
    }

    Ok() {
        this.mblLinkdialogRef.close("Ok");
    }

    Cancel() {
        this.mblLinkdialogRef.close("Cancel");
    }

    Close() {
        this.mblLinkdialogRef.close();
    }


    numberOnly(event: any, value: any): boolean {
        if (value === "percentage" && event.key === ".") {
            return true
        } else {
            const charCode = (event.which) ? event.which : event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                return false;
            }
            return true;
        }
    }


    send() {    
        // this.docUploading = false;
        // if (this.enableOTP == "false") {
        //     this.AuthCode = 0;
        //     this.sendOTP = false;
        // }
        // else {
         

        // }
        this.AuthCode = Math.floor(100000 + Math.random() * 900000);
        this.sendOTP = true;
        var phoneNumber = this.phonenumber.nativeElement.value;
        var min: number;
        var max: number;
        max = Math.pow(10, 11);
        var min = max / 10;
        var number = Math.floor(Math.random() * (max - min + 1)) + min;
        this.image = "" + 23 + this.storageService.getJurisNo() + number;
        var imageId = Number.parseInt(this.image);

        var mobileAttach = new MobileAttach();
        mobileAttach.AuthCode = this.AuthCode;
        mobileAttach.PhoneNumber = phoneNumber;
        mobileAttach.ImgID = this.image;
        mobileAttach.JurisID = this.storageService.getJurisNo();
        this.mobileAttachService.RequestAttachment(mobileAttach).subscribe(
            data => {
              
                if (data.json()) {
                    this.PhonePicres = data.json();
                    this.RetrivePic = true;
                    this.interval = setInterval(()=>{
                        this.RetriveImage()
                    },2000)
                    
                   
                    // this.docUploading = false;  
                    
                } 
                        
            },
            
            error => {
                //this.message = this.pagecontentService.getKeyTxt('Msg_InternalServerError', this.storageService.getLang());
                //this.showLoading = false;
            },
            () => { }
        );
    }
    RetriveImage() {       
        //this.docUploading = true;
        this.mobileAttachService.retriveAttachment(this.image, this.storageService.getJurisNo())
            .then(response => {
                this.retrivePic = response.ImageFileAttach;               
                // this.docUploading = false;

                let currentDate = new Date();
                let index = 0;
                for (let i = 0; i < this.retrivePic.length; i++)
                {
                    var stringLength = this.retrivePic[i].ImageData.length;
                    var sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                    var fileSizeinMB = sizeInBytes / (1024 * 1024);
                    let fileName = this.retrivePic[i].ImageFileName.split('.')[1];
                    let ext = this.retrivePic[i].ImageFileName.substr((this.retrivePic[i].ImageFileName.lastIndexOf('.') + 1));                   
                    this.attachments.push({
                        JurisID: this.storageService.getJurisNo(),
                        RefID: null,
                        SourceID: null,
                        SourceType: null,
                        Category: ext,
                        Description: null,
                        TxtAttachID: Guid.newGuid(),
                        BaseAttachFile: this.retrivePic[i].ImageData,
                        SeqNo: index,
                        FileName: this.retrivePic[i].ImageFileName,
                        Custom1: ext,
                        FileSize: fileSizeinMB,
                        CreatedDttmUTC: currentDate
                    });
                }
              
                this.sendOTP = false;
                this.cmdCloseModel();
            });
    }
    cmdCloseModel(): void {
        if (this.attachments.length > 0) {
            this.mblLinkdialogRef.close(this.attachments);
        }
        else {
            this.mblLinkdialogRef.close();
        }
        if (this.interval) {
            clearInterval(this.interval);
         }
    }

}
class Alert {
    constructor() { }
    message: string;
    message1: string;
    showOkBtn: boolean;
    Success: boolean;
}




// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/common/mobileattachlink.component.ts